const EstimateColors = {
  Sent: "#44B764",
  Request: "#FF820E",
  Declined: "#F94444",
  Approved: "#239BCF",
  "Awaiting Approval": "#DC7C24",
  Draft: "#353A42",
};

export default EstimateColors;
